import { TextField } from '@material-ui/core';
import React, { useState } from 'react';

const StringArrayInput = ({ updatedJob, setUpdatedJob }) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === 'Enter') {
      addStringToArray();
    }
  };

  const addStringToArray = () => {
    if (inputValue.trim() !== '') {
      setUpdatedJob((prev) => {
        return {
          ...prev,
          skills: [...prev.skills, inputValue.trim()],
        };
      });
      setInputValue('');
    }
  };

  const removeStringFromArray = (indexToRemove) => {
    const newArray = updatedJob?.skills?.filter(
      (_, index) => index !== indexToRemove
    );
    setUpdatedJob((prev) => {
      return {
        ...prev,
        skills: newArray,
      };
    });
  };

  return (
    <div className='w-full'>
      <div className='flex gap-4 items-center mb-6'>
        {updatedJob?.skills.map((str, index) => (
          <div
            key={index}
            className='bg-gray-400 text-black py-2 px-4 rounded-full cursor-pointer'
          >
            <span>{str}</span>
            <button
              className='ml-3 '
              onClick={() => removeStringFromArray(index)}
            >
              X
            </button>
          </div>
        ))}
      </div>
      <TextField
        type='text'
        label='Skills'
        variant='outlined'
        fullWidth
        value={inputValue}
        onChange={handleInputChange}
        onKeyUp={handleInputKeyPress}
        placeholder='Enter a skill and press Enter'
      />
    </div>
  );
};

export default StringArrayInput;
